export enum InputType {
  source = "source",
  target = "target",
}
